import { request } from 'Features/auth/axios-client'
import { useMutation, useQuery } from 'react-query'
import { FetchColumnDataParams } from './DataQuality.types'

const fetchDataQuality = async () => {
  const data = await request({
    url: `/plan/data-quality`,
  })
  return data
}

export const useDataQuality = () => {
  return useQuery(['data-quality'], () => fetchDataQuality(), {
    select: ({ data }) => {
      return data?.data.map((row: Record<string, string>, index: number) => {
        return {
          ...row,
          id: index,
        }
      })
    },
    refetchOnWindowFocus: false,
  })
}

const fetchColumnData = async ({
  column,
  workCentreKey,
  workCentreCode,
}: FetchColumnDataParams) => {
  const { data } = await request({
    url: `/plan/data-quality`,
    method: 'POST',
    data: {
      column,
      workCentreKey,
      workCentreCode,
    },
  })
  return data
}

export const useFetchColumnData = (onFail: () => void) => {
  return useMutation(fetchColumnData, {
    onError: onFail,
  })
}
